import { HelpCircle } from 'lucide-react';
import { Link as RouterLink } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function HeaderSimple() {
  return (
    <header className="flex items-center justify-between px-6 py-4">
      <RouterLink to="/">
        <img
          src="/assets/illustrations/Athory_with_text.svg"
          alt="Athory"
          className="h-12 w-auto"
        />
      </RouterLink>

      <a
        href="mailto:support@athory.com"
        className="group inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
      >
        <HelpCircle className="size-4 transition-transform duration-300 group-hover:rotate-12" />
        Need help?
      </a>
    </header>
  );
}
